import { render, staticRenderFns } from "./modifyPass.vue?vue&type=template&id=b2a02244&scoped=true&"
import script from "./modifyPass.vue?vue&type=script&lang=js&"
export * from "./modifyPass.vue?vue&type=script&lang=js&"
import style0 from "./modifyPass.vue?vue&type=style&index=0&id=b2a02244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a02244",
  null
  
)

export default component.exports